/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import {
    Avatar,
    Card,
    Group,
    Button,
    LoadingOverlay,
    NativeSelect,
    Paper,
    Stepper,
    TextInput,
    Title, Select, Alert

} from '@mantine/core';
import { useScrollLock, useViewportSize } from "@mantine/hooks";
import React, {useEffect, useMemo, useRef, useState} from 'react';
import Logo from "../assets/negru.svg";
import {auth, firestore} from "../firebase";
import {collection, doc} from "firebase/firestore";
import {useFirestoreDocumentData, useFirestoreDocumentMutation} from "@react-query-firebase/firestore";
import GeoPattern from "geopattern";
import InputGallery from "../components/Inputs/InputGallery";
import useFirebaseFunction from "../utils/useFirebaseFunction";
import AppLoadingAnimation from "../components/AppLoadingAnimation";
import {useSearchParams} from "react-router-dom";
import {useAuthState} from "react-firebase-hooks/auth";
import {IconAlertCircle} from "@tabler/icons";


const Rsvp = () => {
    const { height:heighViewSize } = useViewportSize();
    const [searchParams, setSearchParams] = useSearchParams();
    const [board, setBoard] = useState();
    const [open_board, isBoardOpening] = useFirebaseFunction("open_board", "europe-west1");
    const [loginLoading, setLoginLoading] = useState(null);
    const [name, setName] = useState(null);
    const [people, setPeople] = useState(null);
    const [status, setStatus] = useState(null);
    const [user, loading] = useAuthState(auth);



    const subdomain = window.location.pathname.replace("/", "");
    const isRsvp = !!searchParams.get("rsvp");

    //const board = useBoardHook(subdomain, false, subdomain === "");
    const refAdmin = doc (collection(firestore, 'public_users'), board?.data?.admin || "a");
    const {data: getAdmin} = useFirestoreDocumentData(['public_users', board?.data?.admin], refAdmin, {}, {enabled: !!board?.data?.admin});
    const rsvpCollection = collection(firestore, `boards/${board?.data?.id}/rsvp`);
    const rsvpRef = doc(rsvpCollection, user?.uid);

    const rsvp = useFirestoreDocumentData(['rsvp', board?.data?.id, user?.uid], rsvpRef, {}, {enabled: !!board?.data?.id})

    const mutationMerge = useFirestoreDocumentMutation(rsvpRef, {
        merge: true,
    });

    const adminAvatar = getAdmin?.avatar;
    const adminFirstName = getAdmin?.firstName;
    const adminLastName = getAdmin?.lastName;
    const adminInitials = adminFirstName?.split('')[0]+adminLastName?.split('')[0];




    useEffect(() => {
        if (subdomain) {
            open_board({subdomain})
                .then((result) => {
                    setBoard(result);
                })
        }
    }, [subdomain]);

    useEffect(() => {
        if (rsvp?.data) {
            setStatus(rsvp.data.status);
            setName(rsvp.data.name);
            setPeople(rsvp.data.people);
        }
    }, [rsvp?.data])


    const onSavePress = () => {
        mutationMerge.mutate({
            name,
            people,
            status
        })
    }

    useEffect(() => {
        if (loginLoading === null) {
            if (!isBoardOpening) {
                return;
            }
        }
        setLoginLoading(isBoardOpening)
    }, [isBoardOpening, loginLoading])

    const backgroundStyling = useMemo(() => {
        let initial = {
            backgroundImage:'url(/background-login.png)',
            backgroundPosition:'center center',
            backgroundSize:'cover'
        };

        if (board?.data) {
            const source = board?.data?.image ? `https://d2uqrxzbny1jco.cloudfront.net/fit-in/1000x1000/${board?.data?.image}` : `${GeoPattern.generate(subdomain).toDataUri()}`;
            initial = {
                backgroundImage: `url('${source}')`,
                backgroundPosition: 'center center',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundColor: 'rgba(0,0,0,0.6)',
                backgroundBlendMode: 'soft-light',
                alignItems: "center",
            }

        }
        return initial;
    }, [board?.data])


    console.log(mutationMerge.isSuccess);

    if (subdomain && (loginLoading === null || loginLoading === true )) {
        return (<LoadingOverlay visible={true} loader={<AppLoadingAnimation/>}/>);
    }
    return (
        <div
            style={{...backgroundStyling,height: heighViewSize+'px'}}
            className="relative w-full flex items-center pt-24 flex-col"
        >
            <div className={` ${!subdomain ? 'max-w-[200px]' : ''} w-full mb-10`}>
                {subdomain  ?
                    board?.data?.title && (<div className="flex flex-col w-full px-4 justify-center items-center">
                        <InputGallery
                            board={board}
                            admin={false}
                            value={"test2"}
                            className="headingTitle"
                        />
                        <InputGallery
                            board={board}
                            admin={false}
                            value={"test"}
                            className="headingDate"
                        />
                    </div>)
                    :
                    <img className="h-full w-full" alt="Picboard" src={Logo}/>}
            </div>


            <div className="max-w-[355px] sm:max-w-[470px] w-full">
                {
                    mutationMerge.isSuccess ? <Alert title="Multumim!" color="teal" variant="filled">
                        Organizatorii evenimentului au primit răspunsul tău
                    </Alert> : (
                        <Card shadow="sm" p="sm" radius="md" withBorder>
                            <Title order={4}>Confirmare participare</Title>
                            <form>
                                <TextInput
                                    mt={"md"}
                                    withAsterisk
                                    label="Numele tău"
                                    value={name || ""}
                                    onChange={(e) => setName(e.target.value)}
                                    placeholder="ex: Ion Popescu"
                                />
                                <Select
                                    mt={"md"}
                                    value={people}
                                    onChange={setPeople}
                                    data={[{value: "1", label: "1 persoana"}, {value:"2", label: "2 persoane"}]}
                                    placeholder="Alege numărul de persoane"
                                    label="Număr persoane"
                                    withAsterisk
                                />
                                <Select
                                    mt={"md"}
                                    value={status}
                                    onChange={setStatus}
                                    data={[{value: "confirmat", label: "Da, confirm prezenta"}, {value:"refuzat", label: "Nu pot să particip"}]}
                                    placeholder="Poți participa la eveniment?"
                                    label="Disponibilitate"
                                    withAsterisk
                                />
                            </form>
                            <Group       mt={"md"}>
                                <Button radius="md" onClick={() => onSavePress()} style={{ flex: 1 }} disabled={!people || !name || !status}>
                                    Salvează
                                </Button>
                            </Group>

                        </Card>
                    )
                }


                {subdomain &&
                    <a href={!!getAdmin?.data?.website.length && getAdmin?.data?.website} target="_blank" rel="noreferrer" className="cursor-pointer absolute flex flex-col justify-center items-center bottom-4 left-1/2 transform -translate-x-1/2">
                        {adminAvatar ?
                            <Avatar className="mb-2" radius="xl" style={{width:'50px',height:'50px'}} src={`https://d2uqrxzbny1jco.cloudfront.net/fit-in/200x200/${adminAvatar}`} alt="AvatarAdmin" />
                            :
                            (!adminAvatar && adminFirstName && adminLastName
                                    ?
                                    <Avatar className="mb-2 uppercase" color="blue" radius="xl" style={{width:'50px',height:'50px'}} src={null} alt="AvatarUser">{adminInitials}</Avatar>
                                    :
                                    <Avatar className="mb-2 uppercase" color="blue" radius="xl" style={{width:'50px',height:'50px'}} src={null} alt="AvatarUser" />
                            )}
                        <h1 className="headingPhotograph">{adminFirstName} {adminLastName}</h1>
                    </a>}


            </div>
        </div>
    )
}

export default Rsvp;